import { render, staticRenderFns } from "./PortraitCell.vue?vue&type=template&id=28c630a6"
import script from "./PortraitCell.vue?vue&type=script&lang=js"
export * from "./PortraitCell.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/import/portrait.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports